import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=e63a9138&"
import script from "./Test.vue?vue&type=script&lang=js&"
export * from "./Test.vue?vue&type=script&lang=js&"
import style0 from "./Test.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e63a9138', component.options)
    } else {
      api.reload('e63a9138', component.options)
    }
    module.hot.accept("./Test.vue?vue&type=template&id=e63a9138&", function () {
      api.rerender('e63a9138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Test/Test.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Test/Test.vue
// module id = urab
// module chunks = 0